(() => {
  const script = document.currentScript;
  const root = (script?.dataset.storeRoot || '/').replace(/\/$/, '');
  const collectionPrefix = `${root}/collections/`;
  const searchPath = `${root}/search`;
  const key = 'miss-daisy:shopping-context';

  function shoppingPath(value) {
    if (!value) return null;

    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return null;

      if (url.pathname.startsWith(collectionPrefix)) {
        const parts = url.pathname.slice(collectionPrefix.length).split('/');
        // Accept collection and tagged-collection paths, never a product URL.
        if (parts.length < 1 || parts.length > 2 || parts.some(part => !part || part === 'products')) return null;
      } else if (url.pathname === searchPath) {
        if (!url.searchParams.get('q')) return null;
      } else {
        return null;
      }

      const params = new URLSearchParams();
      url.searchParams.forEach((value, name) => {
        if (name === 'sort_by' || name === 'page' || name === 'q' || name === 'type' ||
            name === 'options[prefix]' || name.startsWith('filter.')) {
          params.append(name, value);
        }
      });

      return `${url.pathname}${params.size ? `?${params}` : ''}`;
    } catch {
      return null;
    }
  }

  function remember(path) {
    if (path) sessionStorage.setItem(key, path);
  }

  try {
    const current = shoppingPath(location.href);
    if (current) {
      remember(current);
      // Collection/search filters change the URL without a page reload.
      // Capture the final state as the shopper leaves for a product or cart.
      window.addEventListener('pagehide', () => remember(shoppingPath(location.href)));
    } else if (location.pathname.includes('/products/')) {
      const referringContext = shoppingPath(document.referrer);
      const productCollection = shoppingPath(script?.dataset.collectionUrl);
      const previous = shoppingPath(sessionStorage.getItem(key));

      if (referringContext) {
        remember(referringContext);
      } else if (productCollection) {
        // A collection-context product URL still has a useful fallback.
        const base = productCollection.split('?')[0];
        if (!previous || (previous !== base && !previous.startsWith(`${base}/`) && !previous.startsWith(`${base}?`))) {
          remember(base);
        }
      } else {
        // A directly opened PDP should not inherit an unrelated old journey.
        const referrer = document.referrer && new URL(document.referrer, location.origin);
        if (!referrer || referrer.origin !== location.origin || !referrer.pathname.includes('/products/')) {
          sessionStorage.removeItem(key);
        }
      }
    }

    const destination = shoppingPath(sessionStorage.getItem(key));
    if (destination) {
      document.querySelectorAll('[data-continue-shopping]').forEach(link => {
        link.href = destination;
      });
    }
  } catch {
    // The server-rendered Shop All link remains available without storage.
  }
})();
